var map = {
	"./10_nuts.png": 2522,
	"./1drink_12beer.png": 2523,
	"./1serving_8ounces.png": 2524,
	"./1serving_8ounces2.png": 2525,
	"./1serving_8ounces3.png": 2526,
	"./1serving_8ounces4.png": 2527,
	"./1serving_8ounces5.png": 2528,
	"./8ounces_1glass.png": 2529,
	"./can_1.png": 2530,
	"./can_2.png": 2531,
	"./can_3.png": 2532,
	"./cup.png": 2533,
	"./dried_serving_1/4cup.png": 2534,
	"./dried_serving_1:4cup.png": 2535,
	"./fresh_serving_1cup.png": 2536,
	"./glass_1.png": 2537,
	"./glass_2.png": 2538,
	"./golfball.png": 2539,
	"./halfthumb.png": 2540,
	"./hand_1.png": 2541,
	"./hand_2.png": 2542,
	"./hand_3.png": 2543,
	"./hand_4.png": 2544,
	"./hand_5.png": 2545,
	"./how.png": 868,
	"./serving_1/2cup.png": 2546,
	"./serving_1:2cup.png": 2547,
	"./serving_1tbsp.png": 2548,
	"./serving_3/4ounces.png": 2549,
	"./serving_3:4ounces.png": 2550,
	"./thumbx2.png": 2551,
	"./usda.png": 2552,
	"./vegetables_1cup.png": 2553,
	"./what.png": 866,
	"./wholethumb.png": 2554,
	"./why.png": 867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2521;